import { apiClient, fastApiClient } from "../App";

// List
export const getEmailTemplates = (params = {}) => {
  return fastApiClient.get("/email-templates", { params });
};

// Create
export const createEmailTemplate = (data) => {
  return fastApiClient.post("/email-templates", data);
};

// View
export const getEmailTemplate = (id) => {
  return apiClient.get(`/email-templates/${id}/`);
};

// Update
export const updateEmailTemplate = (id, data) => {
  return fastApiClient.put(`/email-templates/${id}`, data);
};

// Delete
export const deleteEmailTemplate = (id) => {
  return fastApiClient.delete(`/email-templates/${id}`);
};

// Clone to Template Library
export const cloneEmailTemplateToLibrary = (id) => {
  return fastApiClient.post(`/template-library/${id}/clone-to-library`);
};

// Remove CID Image
// export const removeCidImage = (id, cid) => {
//   return fastApiClient.delete(`/email-templates/${id}/cid-image/${cid}`);
// };

// // Remove Attachment
// export const removeAttachment = (id, attachmentId) => {
//   return fastApiClient.delete(`/email-templates/${id}/attachments/${attachmentId}`);
// };